var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-toast", {
    attrs: { visible: _vm.showError, variant: _vm.variant },
    on: {
      dismissed: function ($event) {
        return _vm.$store.commit("errors/dismissError")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [_vm._v(_vm._s(_vm.message))]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }